import React from "react";
import { Modal } from "react-bootstrap";

function UniversalViewModal({
  message,
  isConfirmModal,
  handleConfirmHide,
  onClick,
  buttonLabel,
  buttonprintLabel,
  title,
  dataArray,
}) {
  return (
    <>
      <Modal
        show={isConfirmModal}
        onHide={handleConfirmHide}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="xl"
        closeButton
      >
        <Modal.Header closeButton>
          <Modal.Title> {title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center pb-0">
          <div className="row">
            {dataArray &&
              dataArray.length > 0 &&
              dataArray.map((item, index) => (
                <div className="col-md-4 mb-4">
                  <h5 className="text-secondary fs-14 font-weight-normal text-left">
                    {item.key}
                  </h5>
                  <p className="text-dark fs-14 font-weight-bold text-left">
                    {item.value}
                  </p>
                </div>
              ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default UniversalViewModal;
